import { PlanetKeyStatusResponse, PlanetCacheStats } from '../models/TLGeo';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { API_URL_ADMIN } from '~/config/config';

/**
 * Constructs the URL for a Planet tile via the proxy.
 * This does not make a request itself, but returns the URL to be used in image tags or map layers.
 */
export const getPlanetTileUrl = (z: number, x: number, y: number, year: number, month: number): string => {
  // Ensure month is 1-12
  const m = Math.max(1, Math.min(12, month));
  // Ensure year is 4 digits (basic check)
  const yyyy = year;
  
  return `${API_URL_ADMIN}/api/tlgeo-ext/satellite/planet/${yyyy}/${m}/${z}/${x}/${y}.png`;
};

/**
 * Constructs the URL template for a Planet tile via the proxy for map engines.
 */
export const getPlanetTileUrlTemplate = (url: string): string => {
  return url;
};

/**
 * Fetches the status of all Planet API keys managed by the proxy.
 */
export const remote_Planet_getKeyStatus = async (): Promise<PlanetKeyStatusResponse> => {
  return (await getAxiosInstance().get('/api/tlgeo-ext/satellite/planet/keys')).data;
};

/**
 * Fetches the cache statistics for Planet tiles.
 */
export const remote_Planet_getCacheStats = async (): Promise<PlanetCacheStats> => {
  return (await getAxiosInstance().get('/api/tlgeo-ext/satellite/planet/cache-stats')).data;
};

export const remote_Planet_startSeeding = async (year?: string, month?: string) => {
  return (await getAxiosInstance().post('/api/tlgeo-ext/satellite/planet/seed', { year, month })).data;
};

export const remote_Planet_getSeedStatus = async () => {
  return (await getAxiosInstance().get('/api/tlgeo-ext/satellite/planet/seed-status')).data;
};
